<div class="max-w-2xl">
  <div class="flex gap-6 justify-center items-center mb-8">
    <img src="/assets/images/hospitable.png" class="h-8" />
    <mat-icon class="scale-150 text-smoke-darker">sync_alt</mat-icon>
    <img src="/assets/images/connected-accounts/airbnb.svg" class="h-8" />
  </div>

  <p class="mb-6" *ngIf="redirect">
    <strong>Before you downgrade,</strong>
    make sure you are logged in to Airbnb with the account you want to connect to Hospitable.com. You'll be redirected
    to Airbnb to confirm the connection.
  </p>

  <p class="mb-2"><strong>For the properties connected to this account</strong></p>

  <ul class="list list__looser">
    <li>You won't be able to make changes to pricing and availability on your Hospitable calendar</li>
    <li>
      You will need to
      <a class="link" href="https://help.hospitable.com/en/articles/4828978-property-reservations-ical" target="_blank">
        add property iCals ​to Airbnb listings
      </a>
      to sync Direct and manual bookings
    </li>
  </ul>

  <sbnb-loading-spinner *ngIf="loadingProperties$ | async"></sbnb-loading-spinner>

  <div *ngIf="affectedProperties$ | async as properties"
    class="flex flex-col gap-3 border-t border-smoke border-b mt-8 py-6">
    <div class="strong" *ngIf="properties.length">
      Affected Properties
      <span class="badge badge-lemon ml-2">{{ properties?.length }}</span>
    </div>
    <div *ngIf="properties.length" class="max-h-[375px] px-3 overflow-y-auto">
      <mat-list role="list">
        <mat-list-item *ngFor="let property of properties">
          <div class="flex items-center gap-3 py-2" [ngClass]="{ strikethrough: property.muted }">
            <sbnb-mini-listing-img [imgSrc]="property.picture"></sbnb-mini-listing-img>
            <span>{{ property.name }}</span>
          </div>
        </mat-list-item>
      </mat-list>
    </div>
  </div>

  <div class="flex justify-end gap-4 mt-12 mb-12">
    <sbnb-button [disabled]="loading$ | async" type="secondary" routerLink="/accounts">Cancel</sbnb-button>
    <sbnb-button [loading]="loading$ | async" loadingLabel="Downgrading..." label="Confirm"
      (click)="downgrade()"></sbnb-button>
  </div>
</div>
